import { Edit } from '@mui/icons-material';
import { Box, Grid, IconButton, Typography } from '@mui/material';
import { format, setDay } from 'date-fns';
import { useState } from 'react';
import { t } from '../../../constants/translations';
import { useAdmin } from '../../../contexts/admin.context';
import { useLocale } from '../../../contexts/locale.context';
import { dateLocaleMap } from '../../../utils/dates';
import EditWorkHoursModal from './EditWorkHoursModal';

const WorkHours = () => {
  const { cafe } = useAdmin();
  const { lang } = useLocale();

  const [editDay, setEditDay] = useState<number | null>(null);

  return (
    <Box sx={{ pl: 2 }}>
      {[1, 2, 3, 4, 5, 6, 0].map((dayIndex) => {
        const date = setDay(new Date(), dayIndex);
        const hours = cafe?.hours?.[dayIndex];

        return (
          <Grid container key={dayIndex} spacing={1} alignItems="center" mb={2}>
            <Grid item xs={5}>
              <Typography>{format(date, 'EEEE', { locale: dateLocaleMap[lang] })}</Typography>
            </Grid>
            <Grid item xs={5}>
              {!hours && <Typography>{t.closed[lang]}</Typography>}
              {hours && (
                <Box>
                  {hours.map((hour, index) => (
                    <Typography key={index}>
                      {hour?.start} - {hour?.end}
                    </Typography>
                  ))}
                </Box>
              )}
            </Grid>
            <Grid item xs={2}>
              <IconButton onClick={() => setEditDay(dayIndex)}>
                <Edit />
              </IconButton>
            </Grid>
          </Grid>
        );
      })}

      {editDay !== null && <EditWorkHoursModal dayIndex={editDay} onClose={() => setEditDay(null)} />}
    </Box>
  );
};

export default WorkHours;
